export default __webpack_public_path__ + "static/media/services-trading-two.6361bf00.jpg";